<template>
    <div>
        <div v-if="data.contents.length" class="bg-white border rounded mb-2">
            <draggable
                v-model="data.contents"
                handle=".link-handle"
                item-key="unique_id"
                :animation="150"
                class="divide-y"
            >
                <template #item="{ element: link, index }">
                    <div class="p-3 space-y-2">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-2">
                                <button type="button" class="link-handle cursor-move focus:outline-none">
                                    <svg class="w-4 h-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                                </button>
                                <span class="text-sm text-gray-900">Link {{ index + 1 }}</span>
                            </div>
                            <btn type="light" size="xs" @click="removeContent(link.unique_id)">
                                <icon name="delete" size="14" class="mr-1" />
                                Delete
                            </btn>
                        </div>
                        <div class="grid grid-cols-2 gap-2">
                            <text-field
                                v-model="link.title"
                                placeholder="Title"
                            />
                            <text-field
                                v-model="link.url"
                                :prefixes="['https://', 'http://']"
                                placeholder="https://"
                            />
                        </div>
                        <text-field
                            v-model="link.description"
                            placeholder="Description (optional)"
                        />
                    </div>
                </template>
            </draggable>
        </div>

        <div class="flex items-center justify-between">
            <btn type="secondary" size="small" icon-name="add-circle" @click="addContent">Add link</btn>
            <div v-if="data.contents.length" class="flex items-center gap-2">
                <div v-if="data.display_content" class="flex items-center">
                    <span class="text-sm text-gray-400 mr-1">Columns:</span>
                    <select
                        :value="data.columns_count || 2"
                        @change="data.columns_count = Number($event.target.value)"
                        class="border-0 focus:ring-0 leading-4 text-sm text-gray-500 p-0 pr-8 bg-transparent cursor-pointer"
                    >
                        <option :value="2">2</option>
                        <option :value="3">3</option>
                    </select>
                </div>

                <div class="flex items-center">
                    <toggle
                        size="medium"
                        @update:model-value="data.display_content = $event"
                        :model-value="data.display_content ?? false"
                    />
                    <span class="text-sm font-medium">Display in columns</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {defineProps} from 'vue';
import draggable from 'vuedraggable';
import {uniqueId} from '../helpers';

const props = defineProps({
    data: Object
});

props.data.display_content = props.data?.display_content ?? false;
if (!props.data.columns_count) props.data.columns_count = 2;
props.data.contents = props.data?.contents ?? [];

if (!props.data.contents.length) {
    props.data.contents.push({
        unique_id: uniqueId(),
        title: '',
        description: '',
        url: '',
    });
}

const addContent = () => {
    props.data.contents.push({
        unique_id: uniqueId(),
        title: '',
        description: '',
        url: '',
    });
}

const removeContent = (id) => {
    const index = props.data.contents.findIndex(content => content.unique_id === id);
    if (index !== -1) {
        props.data.contents.splice(index, 1);
    }
}
</script>
